<script setup>

import NavButton from '../components/NavButton.vue'

import { store } from '@/store'
</script>
<template>
  <div class="modal-2609 modal__d">
    <div class="m__content">
      <h3>Disclaimer</h3>
      <p>The purpose of this modeller is not to provide financial advice. The Trustee is legally prevented from giving financial advice. It aims to help you better understand how much money you will need for retirement. All benefits from the Scheme are payable in accordance with the Trust Deed and Rules, the legal document governing the Scheme. In the event of any discrepancy between any information provided to you in this presentation and the Trust Deed and Rules, the Trust Deed and Rules will prevail.</p>
      <p>Please click "OK" to indicate that you have read this disclaimer. You will not be able to use the modeller unless you do so.</p>
      <div class="nav-bar">
        <NavButton dir=">" class="no-pn" type="button" tabindex="0" v-on:click="store.closeModal()">OK</NavButton>
      </div>
    </div>
  </div>
</template>
